import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import ListItem from '@material-ui/core/ListItem';
import MenuItem from '@material-ui/core/MenuItem';
import { withTranslation } from 'react-i18next';
import { ListItemIcon } from '@material-ui/core';
import SettingsVoiceOutlinedIcon from '@material-ui/icons/SettingsVoiceOutlined';
import { getSnack } from '../../utils/snackbar';
import { isInternalAudio, ONLY_INTERNAL_AUDIO_MIC_ID } from '../../utils/internalAudio';
import AvaMic from '../../components/Icons/AvaMic';
import LocalStorage, { STORAGE_KEYS } from '../../services/localStorage';
class MicSelector extends React.Component {
    constructor() {
        super(...arguments);
        this.handleChange = (event) => {
            const { setMicSelected, t, setOnlyInternalAudio } = this.props;
            LocalStorage.set(STORAGE_KEYS.SELECTED_MIC_ID, event.target.value);
            setMicSelected(event.target.value, () => {
                getSnack(this.props)(t('macInternalAudio.enabling'));
            });
            setOnlyInternalAudio(event.target.value.includes(ONLY_INTERNAL_AUDIO_MIC_ID));
        };
        this.handleClick = () => {
            if (navigator.mediaDevices) {
                navigator.mediaDevices.getUserMedia({ audio: true });
            }
        };
    }
    componentDidUpdate(prevProps) {
        const { availableMics: prevAvailableMics } = prevProps;
        const { availableMics, setMicSelected, micIdSelected } = this.props;
        if (availableMics.length - prevAvailableMics.length === 1) {
            let newMicValue;
            availableMics.forEach((newMic) => {
                let micFound = false;
                prevAvailableMics.forEach((prevMic) => {
                    if (prevMic.value === newMic.value) {
                        micFound = true;
                    }
                });
                if (!micFound && !isInternalAudio(newMic)) {
                    newMicValue = newMic.value;
                }
            });
            const currentMic = prevAvailableMics.find((m) => m.value === micIdSelected);
            if (isInternalAudio(currentMic)) {
                // We do nothing as we want to stay on "Ava Mic"
            }
            else if (newMicValue) {
                setMicSelected(newMicValue);
            }
        }
    }
    render() {
        const { micIdSelected, availableMics } = this.props;
        if (!micIdSelected) {
            return React.createElement("div", null);
        }
        const selectedMic = availableMics.find((mic) => mic.value === micIdSelected);
        if (!selectedMic || !selectedMic.label) {
            return React.createElement("div", null);
        }
        return (React.createElement("div", null,
            React.createElement(ListItem, { key: "mic_selected", role: undefined, dense: true },
                React.createElement(ListItemIcon, null,
                    React.createElement(SettingsVoiceOutlinedIcon, null)),
                React.createElement(Select, { value: micIdSelected, onChange: this.handleChange, style: { overflow: 'hidden', width: '100%' }, disabled: selectedMic && availableMics.length < 2 }, availableMics.map((x) => (React.createElement(MenuItem, { key: x.value, value: x.value },
                    React.createElement("span", { style: { display: 'flex', alignItems: 'center' } },
                        isInternalAudio(x) && React.createElement(AvaMic, { style: { marginRight: 10 } }),
                        React.createElement("span", null, isInternalAudio(x) ? 'Ava Mic' : x.label)))))))));
    }
}
export default withTranslation()(withTheme(MicSelector));
